// Types pour les transporteurs
export type CarrierType =
  | "ups"
  | "gpx"
  | "ocx"
  | "colissimo"
  | "dpd"
  | "chronopost"
  | "gls"
  | "dhl"
  | "fedex"
  | "bollore"
  | "client";

export interface Livraison {
  id_livraison: number;
  id_acheteur?: number | null;
  libelle: string;
  telephone?: string | null;
  fax?: string | null;
  email?: string | null;
  site_web?: string | null;
  commentaires?: string | null;
  transporteur?: number;
  active?: number;
  supprimer?: string;
}

export interface CarrierInfo {
  id: CarrierType;
  name: string;
  icon: string;
  color: string;
  bgColor: string;
}

export const CARRIERS: Record<CarrierType, CarrierInfo> = {
  ups: {
    id: "ups",
    name: "UPS",
    icon: "fas fa-shipping-fast",
    color: "text-white",
    bgColor: "bg-yellow-600",
  },
  gpx: {
    id: "gpx",
    name: "GPX LOGISTIQUE",
    icon: "fas fa-truck",
    color: "text-white",
    bgColor: "bg-blue-600",
  },
  ocx: {
    id: "ocx",
    name: "OCX",
    icon: "fas fa-plane",
    color: "text-white",
    bgColor: "bg-orange-500",
  },
  colissimo: {
    id: "colissimo",
    name: "Colissimo",
    icon: "fas fa-cube",
    color: "text-white",
    bgColor: "bg-orange-500",
  },
  dpd: {
    id: "dpd",
    name: "DPD",
    icon: "fas fa-cube",
    color: "text-white",
    bgColor: "bg-red-500",
  },
  chronopost: {
    id: "chronopost",
    name: "Chronopost",
    icon: "fas fa-cube",
    color: "text-white",
    bgColor: "bg-blue-500",
  },
  gls: {
    id: "gls",
    name: "GLS",
    icon: "fas fa-arrow-right",
    color: "text-blue-800",
    bgColor: "bg-yellow-400",
  },
  dhl: {
    id: "dhl",
    name: "DHL",
    icon: "fas fa-plane",
    color: "text-red-600",
    bgColor: "bg-yellow-400",
  },
  fedex: {
    id: "fedex",
    name: "FedEx",
    icon: "fas fa-shipping-fast",
    color: "text-white",
    bgColor: "bg-purple-600",
  },
  bollore: {
    id: "bollore",
    name: "Bolloré",
    icon: "fas fa-ship",
    color: "text-white",
    bgColor: "bg-teal-600",
  },
  client: {
    id: "client",
    name: "Transporteur acheteur",
    icon: "fas fa-truck",
    color: "text-gray-700",
    bgColor: "bg-gray-200",
  },
};
